module.exports = __webpack_public_path__ + "media/memory-bank/level3-avatar-521919d1.png";